import { render } from "./InfoInstruct.vue?vue&type=template&id=626cf5d1&scoped=true"
import script from "./InfoInstruct.vue?vue&type=script&lang=js"
export * from "./InfoInstruct.vue?vue&type=script&lang=js"

import "./InfoInstruct.vue?vue&type=style&index=0&id=626cf5d1&scoped=true&lang=css"

import exportComponent from "D:\\Wyspace\\WechatPlatForm_XINXIN\\WechatPlatForm\\Vue.EmployApply\\employVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626cf5d1"]])

export default __exports__